import React from 'react'
import './FAQ.css'
import Common_title from '../common_components/common-title/Common_title'
import { Accordion } from 'react-bootstrap'

const FAQ = () => {
    return (
        <section className='FAQ'>
            <div className='container'>
                <Common_title title="Frequently Asked Questions" />

                <div className='faq_div'>
                    <Accordion defaultActiveKey="0">

                        <Accordion.Item eventKey="0">
                            <Accordion.Header><p className="question_text">What online degree and certificate programs are available at DPU-COL?</p></Accordion.Header>
                            <Accordion.Body>
                                <div className='answer_div'>

                                    <p className='faq_answer_text'>
                                        DPU-COL combines academic excellence, expert faculty, industry-aligned curriculum, and flexible learning to deliver a top-tier online education experience.
                                    </p>

                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header><p className="question_text">Will I need to visit campus for exams or classes?</p></Accordion.Header>
                            <Accordion.Body>
                                <div className='answer_div'>

                                    <p className='faq_answer_text'>
                                        DPU-COL combines academic excellence, expert faculty, industry-aligned curriculum, and flexible learning to deliver a top-tier online education experience.
                                    </p>

                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header><p className="question_text">How can I apply for DPU-COL’s online programs?</p></Accordion.Header>
                            <Accordion.Body>
                                <div className='answer_div'>

                                    <p className='faq_answer_text'>
                                        DPU-COL combines academic excellence, expert faculty, industry-aligned curriculum, and flexible learning to deliver a top-tier online education experience.
                                    </p>

                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header><p className="question_text">Why is DPU-COL considered a top choice for online education?</p></Accordion.Header>
                            <Accordion.Body>
                                <div className='answer_div'>

                                    <p className='faq_answer_text'>
                                        DPU-COL combines academic excellence, expert faculty, industry-aligned curriculum, and flexible learning to deliver a top-tier online education experience.
                                    </p>

                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header><p className="question_text">Will I need to visit campus for exams or classes?</p></Accordion.Header>
                            <Accordion.Body>
                                <div className='answer_div'>

                                    <p className='faq_answer_text'>
                                        DPU-COL combines academic excellence, expert faculty, industry-aligned curriculum, and flexible learning to deliver a top-tier online education experience.
                                    </p>

                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                    </Accordion>
                </div>
            </div>
        </section>
    )
}

export default FAQ
